export default __webpack_public_path__ + "vintage-key-outline.png";